module.exports = __webpack_public_path__ + "media/Gameplay_White_BG_-_Feb_4.mp4";